<template>
  <v-dialog
      v-model="dialog"
      max-width="600"
  >
    <v-card>
      <v-card-title>
        {{ title }}

      </v-card-title>
      <v-card-text class="pt-5">
        <div class="container-xxl-fluid">
          <div class="row">

            <div class="col-lg-12">
              <v-textarea
                  v-model="productObject.property"
                  label="Özellik"
                  filled
                  solo
                  dense
              ></v-textarea>
            </div>

          </div>



        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="secondary" @click="dialog = false">
          İptal
        </v-btn>

        <v-btn text color="primary" @click="addOrUpdateProperty">
          Kaydet
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {mapActions, mapState} from "vuex";

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    product: {}
  },
  computed: {
    ...mapState("auth", ["user"])
  },
  data() {
    return {
      dialog: false,
      productObject: {}
    }

  },
  methods: {
    ...mapActions("stock", ['propertyAdd', 'propertyUpdate']),
    async addOrUpdateProperty() {
      if (this.product.propertyId === "" || this.product.propertyId === null || this.product.propertyId === 0) {
        await this.propertyAdd({
          params: {
            userId: this.user.UserId
          },
          body: {
            "code": this.productObject.code,
            "property": this.productObject.property,
          }
        })


      } else {
        await this.propertyUpdate({
          params: {
            userId: this.user.UserId
          },
          body: {
            "Code": this.productObject.code,
            "Property": this.productObject.property,
            "Id": this.productObject.propertyId
          }
        })
      }
      this.dialog = false
    }
  },
  watch: {
    "dialog": function (newVal) {
      this.$emit("dialogChange", newVal)
    },
    "showDialog": function (newVal) {
      this.dialog = newVal
    },
    "product": function (newVal) {
      this.productObject = Object.assign({}, newVal);
    }

  }
}

</script>